module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/17LsBgD/tc-custom/9781423608554.jpg?1736883580967",
      "alt": "This image is the cover for the book 101 Things To Do With A Cake Mix, 101 Things To Do With"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("101 Things To Do With A Cake Mix, 101 Things To Do With\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The "), _c('i', [_vm._v("New York Times–")]), _vm._v("bestselling phenomenon. “From Hawaiian Pineapple to luscious Lemonade Cake, the recipes are foolproof ways of faking homemade.” —"), _c('i', [_vm._v("First for Women")])]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Move over Betty Crocker—"), _c('i', [_vm._v("101 Things to Do with a Cake Mix ")]), _vm._v("will amaze your friends and leave them Jell-O green with envy! From Snickers Surprise Cookies to Christmas Rainbow Poke Cake, it’s the best thing to happen in the kitchen since your last romantic rendezvous! So what are you waiting for? Grab a cake mix, whip up some goodies, and throw some flour on your face so it looks like you spent days in the kitchen."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Simple and sweetly satisfying recipes include Heavenly Brownies, German Chocolate Bars, Easy Snicker Doodles, Choco Sandwich Cookies, Lemon-Lime Refrigerator Cake, Valentine Love Cake, Peppermint Cake, Swiss-Chocolate Dump Cake, Pistachio Pound Cake, Quick and Easy Cornbread, Jack-O-Lantern Cake, Delicious Dirt, and more.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stephanie Ashcraft\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Stephanie Ashcraft, author of the original 101 Things To Do With A Cake Mix, has taught cooking classes based on the tips and meals in her cookbooks for almost twenty years. She lives in Tucson, Arizona.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0